import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import Icon from "@/icons";
import { useState } from "react";
import { Channel } from "types";
import UpdateDetails from "./ChannelSettings/UpdateDetails";
import UpdatePermissions from "./ChannelSettings/UpdatePermissions";
import VoiceSettings from "./ChannelSettings/VoiceSettings";

export const UpdateChannel = ({ children, channel, full, isOpenF, setIsOpenF }: { children: React.ReactNode, channel: Channel, full?: boolean, isOpenF?:any, setIsOpenF?: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('overview');
    const isActive = (option: string) => {
        return option === selectedOption ? 'bg-brand-profile'
            : 'bg-brand-dark';
    }



    return (
        <Dialog open={
            isOpenF ? isOpenF : isOpen
        } onOpenChange={
            (isOpen) => {
                if(isOpenF) return setIsOpenF(isOpen);
                setIsOpen(isOpen);
            }
        }>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <DialogContent className="min-w-full rounded-none bg-brand-back border-none sm:rounded-none sm:h-screen sm:max-w-4xl flex flex-col sm:flex-row p-0 overflow-auto">
                <div className="px-4 py-6 bg-brand-dark w-full sm:w-1/4 sm:px-8 overflow-auto" style={{ scrollbarWidth: "none" }}>
                    <div className="flex flex-col items-start w-full h-full sm:h-screen p-4 font-semibold overflow-auto">
                        <div className="flex flex-col items-center justify-center text-gray-200 rounded-full">
                            <span>
                                #{channel.name} Channel Settings
                            </span>
                        </div>
                        <div className="w-full mt-4 items-start justify-between space-y-2 flex flex-col">
                            <button
                                onClick={() => {
                                    setSelectedOption('overview');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('overview')}`}
                            >
                                Overview
                            </button>

                            <button
                                onClick={() => {
                                    setSelectedOption('permissions');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('permissions')}`}
                            >
                                Permissions
                            </button>
                            {/*
                            {channel.type === 'voice' && (
                                <button
                                    onClick={() => {
                                        setSelectedOption('voice');
                                    }}
                                    className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('voice')}`}
                                >
                                    Voice Settings
                                </button>
                            )}
                            */}
                        </div>
                    </div>
                </div>
                <div className="w-full sm:w-3/4 p-4 py-12 sm:overflow-hidden max-h-96 sm:max-h-full overflow-auto">
                    <DialogHeader>
                        <DialogTitle>
                            {selectedOption === 'overview' && (
                                <div className="flex items-center gap-4">
                                    <Icon name="settings" size="24" color="white" />
                                    <h1 className="text-gray-200 font-semibold text-lg">Overview</h1>
                                </div>
                            )}

                            {selectedOption === 'permissions' && (
                                <div className="flex items-center gap-4">
                                    <Icon name="settings" size="24" color="white" />
                                    <h1 className="text-gray-200 font-semibold text-lg">Permissions</h1>
                                </div>
                            )}

                            {selectedOption === 'voice' && (
                                <div className="flex items-center gap-4">
                                    <Icon name="settings" size="24" color="white" />
                                    <h1 className="text-gray-200 font-semibold text-lg">Voice Settings</h1>
                                </div>
                            )}
                        </DialogTitle>
                        <DialogDescription>
                        </DialogDescription>
                    </DialogHeader>
                    <div className="w-full">
                        {selectedOption === 'overview' && (
                            <UpdateDetails channel={channel} />
                        ) || selectedOption === 'permissions' && (
                            <UpdatePermissions channel={channel} />
                        ) || selectedOption === 'voice' && (
                            <VoiceSettings channel={channel} />
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
